import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Wheel } from 'spin-wheel';
import { Config } from '../../common/config';
// header.js 에서 쓰는 것과 같은 파일. 이미지 자체가 '내기프트' 워드마크다.
import naegiftLogo from '../../images/naegift_ko_logo.png';

// 현장 이벤트 룰렛 — URL 직접 접근 전용(/event/roulette). 헤더/푸터 없음, 한국어 전용.
// 색상은 Claude Design 시안 확정값.
// ★PURPLE/IVORY 는 SOLD OUT 전체화면(.rlt-full)이 아직 쓰고 있어 남긴다.
//  GOLD/ORANGE/DEEP 은 파스텔 전환으로 쓰는 곳이 없어져 지웠다.
const PURPLE = '#6B2B5F';
const IVORY = '#FFF6E8';
// 가을 파스텔 팔레트. 기존 자주/금색 세트를 화면에서 대체한다.
// ★알록달록해 보이는 원인은 색 개수가 아니라 채도다.
//  한 단계 올렸던 3색이 노랑/주황/보라로 읽혀 채도를 다시 낮춘다.
//  쿠폰은 4색으로 늘리되 명도를 비슷하게 맞춰 한 세트로 보이게 한다.
const CREAM = '#F5E3B3'; // 크림 옐로우 (was #F5CB5C)
const PEACH = '#F7D2BA'; // 피치·살구 (was #F79A66)
const LAVENDER = '#D8CFE8'; // 라벤더 (was #A895D6)
const SAGE = '#CFDDCB'; // 아주 연한 세이지 (신규)
// ★쿠폰 4색이 전부 연해졌으므로 코랄만 진하게 남겨 유일한 포인트로 쓴다.
//  #E05A45 는 빨강으로 읽혀 채도를 낮춘 테라코타 톤으로 내렸다.
const CORAL = '#C9604C'; // was #E05A45
const AGOLD = '#E5B84B';
const CANVAS_IVORY = '#FFF9ED';
// 파스텔 위에서 읽히는 진한 갈색. 본문·라벨 기본색.
const BROWN = '#4A3226';
// 조각 구분선. 쿠폰 4색이 전부 연해져 경계가 사라지므로 한 톤 진하게
// 잡는다. 파스텔 4색·코랄 어디에 붙어도 선이 보이는 따뜻한 토프.
const LINE_TAUPE = '#A8927A'; // was #B08E6A
// 안내/대기 화면 전용. 시안 팔레트 밖이지만 기존 디자인을 유지한다.
const WHITE = '#FFFFFF';
const TEXT = '#333333';
// 소진된 상품 칸. 상품명 대신 소진 표시를 띄운다.
const GRAY_BG = '#CCCCCC';
const GRAY_LABEL = '#333333';
const SOLD_OUT_LABEL = 'SOLD OUT';

// 금테 위 전구 개수. 36개 = 10도 간격. 각도를 미리 만들어 두고 재사용한다.
const BULB_COUNT = 36;
const BULBS = Array.from(
  { length: BULB_COUNT },
  (_, i) => (i * 360) / BULB_COUNT
);

const SPIN_DURATION = 4000;
const SPIN_REVOLUTIONS = 3;
// 대기·SOLD OUT 화면 공통 폴링 간격.
const POLL_MS = 5000;

const JSON_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

// 응답이 { data: {...} } 로 감싸져 오는 경우와 최상위로 오는 경우를 모두 받는다.
const unwrap = res => {
  const body = res && res.data;
  if (!body || typeof body !== 'object') return body;
  const isEnvelope =
    'data' in body && !('eventNo' in body) && !('resultType' in body);
  return isEnvelope ? body.data : body;
};

// eventNo 가 있으면 `${base}event/{eventNo}/active`, 없으면 기존 `${base}event/active`.
// config.js 에 키를 늘리지 않고 API_EVENT_ACTIVE 에서 base 를 되뽑아 조립한다.
const buildActiveUrl = eventNo => {
  const url = Config.API_EVENT_ACTIVE;
  if (!eventNo) return url;
  const base = url.replace(/event\/active\/?$/, '');
  if (base === url) {
    // REACT_APP_API_EVENT_ACTIVE 를 다른 형태로 덮어쓴 경우. 조립할 수 없다.
    console.error(
      '[roulette] API_EVENT_ACTIVE 형식이 예상과 달라 eventNo 경로를 만들 수 없다',
      url
    );
    return url;
  }
  return `${base}event/${eventNo}/active`;
};

// (eventNo, curRound) 를 32bit 정수 시드로 만든다.
// ★같은 입력이면 항상 같은 값 — 새로고침해도 배치가 유지된다.
const makeSeed = (eventNo, curRound) => {
  const a = Number.isFinite(Number(eventNo)) ? Number(eventNo) : 0;
  const b = Number.isFinite(Number(curRound)) ? Number(curRound) : 0;
  let h = Math.imul(a, 0x9e3779b1) ^ (b + 0x85ebca6b + (a << 6) + (a >>> 2));
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  return (h ^ (h >>> 16)) >>> 0;
};

// mulberry32 — 시드 1개로 동작하는 의사난수 생성기. [0,1) 을 돌려준다.
// ★외부 라이브러리 없이 직접 구현한다.
const mulberry32 = seed => {
  let t = seed >>> 0;
  return () => {
    t = (t + 0x6d2b79f5) >>> 0;
    let x = t;
    x = Math.imul(x ^ (x >>> 15), x | 1);
    x ^= x + Math.imul(x ^ (x >>> 7), x | 61);
    return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
  };
};

// Fisher-Yates. 난수원을 인자로 받아 시드 결정성을 유지한다.
const shuffleInPlace = (arr, rand) => {
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rand() * (i + 1));
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  return arr;
};

/**
 * 서버가 준 slots 를 섞는다. 회차당 1회만 호출해 이후 고정.
 * ★기프트 칸끼리 인접하지 않게 배치한다 — 코랄이 붙으면 덩어리로 보인다.
 * ★휠은 원형이라 첫 칸과 마지막 칸도 인접으로 본다.
 *
 * 배치 방법
 *  1) 기프트 g개와 쿠폰 c개로 나눈다(n = g + c).
 *  2) 쿠폰 c개를 원형으로 놓으면 쿠폰 사이 간격이 c개 생긴다.
 *     그중 서로 다른 g개를 골라 각 간격에 기프트를 1개씩만 넣으면
 *     기프트 사이에는 반드시 쿠폰이 1개 이상 들어간다.
 *     ★간격이 서로 달라야 하므로 g <= c, 즉 2g <= n 이어야 한다.
 *      12칸이면 기프트 6개까지 가능하다(현재 최대 5개).
 *  3) 마지막에 시드 기반 회전을 한 번 준다. 회전은 원형 인접 관계를
 *     바꾸지 않으면서 기프트가 늘 같은 자리에서 시작하는 것을 막는다.
 *
 * ★기프트가 너무 많아(2g > n) 인접 없이 배치할 수 없으면 에러를 내지 않고
 *  기존 방식(전체 Fisher-Yates)으로 폴백한다.
 * ★난수는 전부 mulberry32(seed) 하나에서 뽑는다 — 같은 시드면 같은 배치다.
 */
const shuffleSlots = (slots, seed) => {
  const all = [...(slots ?? [])];
  const rand = mulberry32(seed);

  const gifts = all.filter(s => s.type === 'GIFT');
  const coupons = all.filter(s => s.type !== 'GIFT');
  const n = all.length;

  // 폴백 — 기프트가 없거나(분산할 게 없다) 인접 없이 못 넣는 경우.
  if (gifts.length === 0 || gifts.length * 2 > n) {
    return shuffleInPlace(all, rand);
  }

  // 어떤 기프트가 어디로 갈지, 쿠폰 3색 순환 순서도 시드로 섞는다.
  shuffleInPlace(gifts, rand);
  shuffleInPlace(coupons, rand);

  // 쿠폰 사이 간격 c개 중 서로 다른 g개를 시드로 고른다.
  const gapOrder = shuffleInPlace(
    coupons.map((_, i) => i),
    rand
  );
  const chosen = new Set(gapOrder.slice(0, gifts.length));

  // 쿠폰을 순서대로 놓고, 선택된 간격 뒤에만 기프트를 하나씩 끼운다.
  const laid = [];
  let g = 0;
  for (let i = 0; i < coupons.length; i += 1) {
    laid.push(coupons[i]);
    if (chosen.has(i)) {
      laid.push(gifts[g]);
      g += 1;
    }
  }

  // 시드 기반 회전. laid[0] 은 항상 쿠폰이라 이게 없으면 배치가 고착된다.
  const offset = Math.floor(rand() * laid.length);
  return laid.slice(offset).concat(laid.slice(0, offset));
};

// 라벨 길이 상한. 근거: itemLabelAlign 'center' 라 가용 폭이 2배가 된다
// (wheel.js resize: _labelMaxWidth *= 2). (0.72 - 0.35) x 2 = 0.74R 이고,
// 휠 지름 min(60vh,60vw) 기준 1080p 노트북에서 약 228px 이다.
// spin-wheel 은 가장 긴 라벨에 맞춰 휠 전체 폰트를 줄이므로(wheel.js resize),
// 상한 폰트(약 23px)를 지키려면 한글 9자가 한계다.
// ★팝업에는 전체 이름이 나오므로 정보 손실은 없다.
const LABEL_MAX_LEN = 9;

const toLabel = slot => {
  if (slot.type === 'COUPON') return '할인쿠폰';
  const name = slot.itemName ?? '';
  if (!name) return '기프트';
  return name.length > LABEL_MAX_LEN
    ? `${name.slice(0, LABEL_MAX_LEN)}…`
    : name;
};

// 칸 색은 타입 기준이다 — 기프트가 색으로 바로 구분돼야 한다.
/** 기프트 칸 배경. 쿠폰(파스텔 4색)보다 확실히 진한 코랄 단색. */
const GIFT_BG = CORAL;
/** 기프트 칸 라벨. 코랄 배경 위 아이보리. */
const GIFT_LABEL = CANVAS_IVORY;
/** 쿠폰 칸 배경. 크림/피치/라벤더/세이지 4색 순환. */
const COUPON_BG = [CREAM, PEACH, LAVENDER, SAGE];
/**
 * 쿠폰 칸 라벨. 파스텔 배경 위 진한 갈색.
 * ★4색 전부에서 대비를 확인했다(WCAG 명도대비).
 *  크림 9.2 / 피치 8.6 / 라벤더 8.1 / 세이지 8.4 — 모두 충분해 그대로 둔다.
 */
const COUPON_LABEL = BROWN;

const toWheelItems = slots => {
  // ★쿠폰 2톤 교차는 쿠폰 칸끼리의 순번으로 센다.
  //  전체 인덱스로 세면 사이에 낀 기프트 칸 때문에 교차가 깨진다.
  let couponSeq = 0;
  return slots.map(slot => {
    const isGift = slot.type === 'GIFT';
    const bg = isGift
      ? GIFT_BG
      : COUPON_BG[couponSeq++ % COUPON_BG.length];
    return {
      label: slot.soldOut ? SOLD_OUT_LABEL : toLabel(slot),
      // 소진 칸은 타입과 무관하게 회색이 우선한다.
      backgroundColor: slot.soldOut ? GRAY_BG : bg,
      labelColor: slot.soldOut
        ? GRAY_LABEL
        : isGift
          ? GIFT_LABEL
          : COUPON_LABEL,
      // 소진 처리 시 findIndex 로 칸을 찾는 키. COUPON 은 null.
      value: isGift ? slot.itemNo : null,
    };
  });
};

const RLT_CSS = `
/* layout.css 의 전역 리셋이 div/span/button 에 font-family·line-height·color·
   letter-spacing 을 직접 건다. 부모에서 상속시킬 수 없으므로 클래스 셀렉터로
   한 번 되돌린다. 개별 규칙은 이 아래에 있어 필요한 값을 그대로 덮는다. */
.rlt-root,.rlt-root *{font-family:'Noto Sans KR','Malgun Gothic',sans-serif;
  letter-spacing:normal;line-height:normal;color:inherit;}
/* 배경은 아이보리(#FFF9ED) 기반. 가운데만 살짝 밝게 둬 깊이를 준다.
   ★배경이 밝아졌으므로 그 위의 글자는 전부 진한 갈색으로 맞춘다. */
.rlt-root{position:fixed;inset:0;z-index:9000;display:flex;flex-direction:column;
  align-items:center;justify-content:space-between;color:${BROWN};
  background:radial-gradient(120% 100% at 50% 42%,
    #FFFDF6 0%,${CANVAS_IVORY} 45%,#FBEFDA 100%);
  overflow:hidden;user-select:none;}
.rlt-top{width:100%;padding:1.6vh 0 0;text-align:center;}
.rlt-title{font-size:4vh;font-weight:800;letter-spacing:-0.02em;line-height:1.2;
  color:${BROWN};text-shadow:0 0.2vh 0.5vh rgba(176,142,106,.35);}
.rlt-round{margin-top:0.8vh;font-size:2.6vh;font-weight:600;opacity:.8;
  color:${BROWN};}
/* 좌상단 로고. png 를 마스크로 써서 단색으로 찍는다.
   ★배경이 아이보리로 바뀌어 아이보리 로고는 사라진다 — 진한 갈색으로. */
.rlt-logo{position:absolute;top:2vh;left:2.2vw;z-index:7;pointer-events:none;
  width:13vh;height:3.2vh;background:${BROWN};opacity:.92;
  -webkit-mask-image:url(${naegiftLogo});mask-image:url(${naegiftLogo});
  -webkit-mask-size:contain;mask-size:contain;
  -webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;
  -webkit-mask-position:left center;mask-position:left center;
  filter:drop-shadow(0 0.2vh 0.5vh rgba(176,142,106,.45));}
.rlt-stage{flex:1 1 auto;display:flex;align-items:center;justify-content:center;width:100%;}
/* 휠은 세로 여백을 최대한 먹는다. 60vh 는 1615x911 에서 546px 밖에 안 나와
   위아래가 크게 남았다. 세로에서 빼야 하는 고정 영역은 다음과 같다.
     제목 영역(.rlt-top)      1.6 + 3.4x1.2 + 0.8 + 2.2x1.5  = 약 9.8vh
     포인터가 휠 위로 튀어나옴(.rlt-pointer top:-1.2vh)      = 1.2vh
     START 영역(.rlt-bottom)  8vh 버튼 + 2vh 아래 여백       = 10vh
   합 약 21vh + 여유 1vh -> 78vh 를 휠에 준다(911px 에서 약 710px).
   가로가 좁은 화면에서는 90vw 가 먼저 걸려 정사각형이 유지된다. */
.rlt-wheel-wrap{position:relative;width:min(78vh,90vw);height:min(78vh,90vw);}
/* 금테. 휠 바깥을 감싸는 원형 링이다.
   ★링을 wrap 밖으로 내보내면 세로 여유(약 1vh)를 넘겨 잘린다.
    그래서 wrap 을 링의 바깥 지름으로 쓰고 캔버스를 안쪽으로 넣는다.
    min(78vh,90vw) 계산식은 그대로다. */
.rlt-ring{position:absolute;inset:0;border-radius:50%;z-index:1;
  background:conic-gradient(from 200deg,
    #9C7A2E 0%,${AGOLD} 12%,#FFEFC2 22%,#C9A23C 34%,${AGOLD} 46%,
    #8A6A24 58%,${AGOLD} 72%,#FFE6A8 86%,#9C7A2E 100%);
  box-shadow:0 1vh 2.8vh rgba(140,106,50,.35),
    inset 0 0 1vh rgba(120,90,40,.35);}
/* 캔버스는 링 안쪽. 3.6% 가 금테 폭이 된다(710px 기준 약 26px).
   ★2.8% 로는 전구 + 글로우가 링 폭을 넘어 바깥으로 삐져나왔다. */
.rlt-wheel{position:absolute;top:3.6%;left:3.6%;width:92.8%;height:92.8%;z-index:2;}
/* 전구. 각 span 이 wrap 전체를 덮고 회전만 다르다 — ::before 가 12시에
   고정돼 있어 회전각이 곧 배치각이 된다. */
.rlt-bulbs{position:absolute;inset:0;z-index:4;pointer-events:none;}
.rlt-bulb{position:absolute;inset:0;}
/* 전구 중심 = 금테 링 폭의 정중앙. wrap 한 변을 S 로 두고 계산한다.
     링 바깥 반지름  R_out = 50%                     (.rlt-ring inset:0)
     캔버스 크기     92.8%                           (.rlt-wheel)
     ★spin-wheel 은 캔버스에 꽉 채워 그리지 않는다. Wheel.radius 기본값이
      0.95 다(node_modules/spin-wheel/src/constants.js:50, wheel.js:150
      _actualRadius = (_size / 2) * radius). 우리는 이 옵션을 주지 않는다.
     링 안쪽 반지름  R_in  = 0.95 x 92.8% / 2 = 44.08%
     금테 실제 두께        = 50% - 44.08%      = 5.92%
     링 폭 중앙 반지름     = (50 + 44.08) / 2  = 47.04%
     위 가장자리로부터 거리 = 50% - 47.04%     = 2.96%   <- top 값
   ★이전 1.8% 는 캔버스 inset(3.6%)의 절반이었다. 0.95 를 빼먹어
    실제 금테보다 안쪽을 기준으로 잡는 바람에 바깥으로 치우쳤다. */
/* ★배경이 아이보리로 바뀌면서 '아이보리 점 + 금색 글로우' 는 금테 위에서
    거의 사라졌다. 흰 코어에 갈색 테두리 링을 둘러 형태를 만들고,
    글로우는 코랄로 바꿔 금색 위에서도 색이 남게 했다.
    점멸도 opacity 0.2 -> 0.4 까지만 흐려지게 해 완전히 지워지지 않게 한다. */
.rlt-bulb::before{content:'';position:absolute;top:2.96%;left:50%;
  width:1.4%;height:1.4%;transform:translate(-50%,-50%);border-radius:50%;
  background:#FFFDF6;
  box-shadow:0 0 0 0.18vh rgba(122,86,40,.6),
    0 0 0.5vh rgba(255,253,246,.95),0 0 1vh rgba(244,127,107,.75);
  animation:rlt-blink 1.2s ease-in-out infinite;}
/* 홀짝 교차 점멸. */
.rlt-bulb:nth-child(odd)::before{animation-delay:0s;}
.rlt-bulb:nth-child(even)::before{animation-delay:.6s;}
@keyframes rlt-blink{0%,100%{opacity:1;}50%{opacity:.4;}}
/* 포인터. 물방울/방패 형태로 뾰족한 끝이 휠 중심(아래)을 향한다.
   ★5.6vh x 7.3vh 도 여전히 커서 회차 텍스트와 간격이 부족했다.
    다시 70% 인 3.9vh x 5.1vh 로 줄이고 top 을 -1.6vh -> 0.6vh 로
    내린다. 위쪽 끝이 금테 바깥으로 나가지 않아 세로 여유가 생긴다.
   ★끝점 = 0.6 + 5.1 = 5.7vh 로 이전과 같다. 금테(두께 약 4.6vh)를
    지나 휠 원 안으로 약 1.1vh 들어가는 정도가 유지된다.
   ★absolute 라 레이아웃 높이를 먹지 않는다.
   ★clip-path 는 border 를 못 쓴다 — 바깥 요소를 밝은 금색 단색으로 깔고
    ::before 를 6% 안쪽에 같은 모양으로 얹어 테두리처럼 보이게 한다.
   ★z-index 8 — 금테(1)·캔버스(2)·전구(4)·허브(5)보다 위.
   ★시각적 위치만 바뀐다. spin-wheel 의 pointerAngle 0(12시) 은 그대로다.
   ★clip-path 는 위가 둥글고 아래 한 점(50% 100%)으로 모이는 핀 모양이다.
    좌우 대칭 좌표쌍으로 찍었다. 형태·색상은 그대로 두고 치수만 줄인다. */
.rlt-pointer{position:absolute;top:0.6vh;left:50%;transform:translateX(-50%);
  width:3.9vh;height:5.1vh;z-index:8;
  background:#FFF0B0;
  clip-path:polygon(50% 100%,34% 70%,18% 50%,6% 33%,2% 21%,
    7% 11%,18% 3.5%,33% 0,50% 0,67% 0,82% 3.5%,93% 11%,98% 21%,
    94% 33%,82% 50%,66% 70%);
  filter:drop-shadow(0 0 0.3vh ${BROWN}) drop-shadow(0 0 0.3vh ${BROWN})
    drop-shadow(0 0.5vh 1vh rgba(140,106,50,.5));}
/* 안쪽 면. 6% 여백이 곧 밝은 금색 테두리 폭이 된다. */
.rlt-pointer::before{content:'';position:absolute;top:6%;left:6%;right:6%;
  bottom:6%;
  background:linear-gradient(180deg,#FFEFC2 0%,${AGOLD} 46%,${CORAL} 100%);
  clip-path:polygon(50% 100%,34% 70%,18% 50%,6% 33%,2% 21%,
    7% 11%,18% 3.5%,33% 0,50% 0,67% 0,82% 3.5%,93% 11%,98% 21%,
    94% 33%,82% 50%,66% 70%);}
/* 상단 안쪽 자주색 원형 포인트. */
.rlt-pointer::after{content:'';position:absolute;top:1.26vh;left:50%;
  width:1.4vh;height:1.4vh;transform:translate(-50%,-50%);border-radius:50%;
  background:${BROWN};
  box-shadow:inset 0 0.3vh 0.6vh rgba(0,0,0,.45),
    0 0 0 0.22vh rgba(255,239,194,.9);}
/* 휠 중앙 장식. 클릭 대상이 아니다 — START 는 휠 아래로 내려갔다. */
.rlt-hub{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
  width:20%;height:20%;border-radius:50%;background:${CANVAS_IVORY};
  border:0.7vh solid ${AGOLD};z-index:5;pointer-events:none;
  box-shadow:0 0.2vh 0.6vh rgba(140,106,50,.35);}
.rlt-start{width:min(40vh,40vw);height:8vh;border:0;border-radius:1.6vh;
  /* ★휠 기프트 칸과 같은 코랄 계열이되 버튼 쪽을 밝게 둬 구분한다.
     글자는 살구/코랄 위에서 대비가 가장 큰 진한 갈색. */
  background:radial-gradient(120% 120% at 50% 22%,
    #FFD9B0 0%,#FFA574 36%,#F2795E 100%);
  color:${BROWN};font-size:3.2vh;font-weight:900;letter-spacing:0.04em;
  cursor:pointer;
  box-shadow:0 0.6vh 1.4vh rgba(140,106,50,.35),
    inset 0 0.2vh 0 rgba(255,255,255,.6);}
.rlt-start:disabled{cursor:default;opacity:.5;}
/* START 버튼만 맨 아래. 잔여 기프트 표시는 제거했다. */
.rlt-bottom{width:100%;padding:0 0 2vh;text-align:center;display:flex;
  flex-direction:column;align-items:center;}
/* 배경이 아이보리라 밝은 토스트는 묻힌다 — 코랄로 띄운다. */
.rlt-error{position:absolute;left:50%;bottom:11vh;transform:translateX(-50%);
  padding:1.2vh 2.4vh;border-radius:1vh;
  background:linear-gradient(180deg,#F79483,${CORAL});color:${CANVAS_IVORY};
  font-size:2vh;font-weight:700;z-index:8;
  box-shadow:0 0.4vh 1.2vh rgba(140,106,50,.4);}
/* 결과 팝업. 따뜻한 갈색 + blur 오버레이 위에 아이보리 카드를 띄운다. */
.rlt-dim{position:absolute;inset:0;z-index:10;display:flex;flex-direction:column;
  align-items:center;justify-content:center;text-align:center;
  background:rgba(74,50,38,.55);
  -webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);
  animation:rlt-fade .18s ease-out;}
/* 금색 테두리(border) + 자주 외곽선(box-shadow 로 두 번째 링). */
.rlt-panel{position:relative;min-width:48vh;max-width:80vw;
  padding:6.4vh 6vh 5vh;border-radius:2.4vh;
  background:linear-gradient(180deg,#FFFDF6 0%,${CANVAS_IVORY} 55%,#FBEBD3 100%);
  color:${BROWN};border:0.5vh solid ${AGOLD};
  box-shadow:0 0 0 0.9vh ${BROWN},0 2vh 4vh rgba(74,50,38,.4);
  animation:rlt-pop .26s cubic-bezier(.2,.9,.3,1.3);}
/* 상단 배지 — 당첨/쿠폰을 색으로 구분한다. */
.rlt-badge{position:absolute;top:-2.2vh;left:50%;transform:translateX(-50%);
  padding:0.9vh 3.2vh;border-radius:3vh;font-size:2vh;font-weight:900;
  letter-spacing:.06em;white-space:nowrap;
  box-shadow:0 0.4vh 1vh rgba(74,50,38,.35);}
/* 당첨은 코랄, 쿠폰은 라벤더로 구분한다. */
.rlt-badge--gift{background:linear-gradient(180deg,#FFEFC2,${AGOLD} 45%,${CORAL});
  color:${BROWN};border:0.25vh solid ${BROWN};}
.rlt-badge--coupon{background:linear-gradient(180deg,#EDE8F5,${LAVENDER} 60%,#BDB0DC);
  color:${BROWN};border:0.25vh solid ${BROWN};}
.rlt-panel-head{font-size:3.4vh;font-weight:800;line-height:1.25;opacity:.8;
  color:${BROWN};}
/* 상품명은 크게. 팝업에서 가장 먼저 읽혀야 한다. */
.rlt-panel-body{margin-top:2vh;font-size:5vh;font-weight:900;line-height:1.25;
  letter-spacing:-0.02em;color:${CORAL};}
/* 쿠폰 팝업은 윗줄(.rlt-panel-head)이 없다. 큰줄이 첫 줄이 되므로
   margin-top 을 지워 배지와의 간격을 기프트 팝업과 같게 맞춘다
   (배지 아래 약 4.8vh). */
.rlt-panel-body--lead{margin-top:0;}
.rlt-panel-note{margin-top:1.6vh;font-size:2.2vh;font-weight:500;opacity:.7;
  color:${BROWN};}
.rlt-panel-btn{margin-top:4vh;padding:1.6vh 6vh;border:0.3vh solid ${BROWN};
  border-radius:1.2vh;
  background:linear-gradient(180deg,#FFEFC2,${AGOLD} 50%,${CORAL});
  color:${BROWN};font-size:2.4vh;font-weight:800;cursor:pointer;
  box-shadow:0 0.5vh 1.2vh rgba(74,50,38,.3);}
@keyframes rlt-fade{from{opacity:0;}to{opacity:1;}}
@keyframes rlt-pop{from{opacity:0;transform:scale(.86) translateY(2vh);}
  to{opacity:1;transform:scale(1) translateY(0);}}
.rlt-full{position:absolute;inset:0;z-index:20;display:flex;flex-direction:column;
  align-items:center;justify-content:center;text-align:center;background:${PURPLE};
  color:${IVORY};padding:0 6vw;}
.rlt-full-head{font-size:8vh;font-weight:900;letter-spacing:-0.02em;line-height:1.15;
  color:${IVORY};}
.rlt-full-sub{margin-top:3vh;font-size:3vh;font-weight:600;opacity:.9;line-height:1.4;
  color:${IVORY};}

/* 안내/대기 화면 — 자주색은 룰렛이 도는 화면과 SOLD OUT 에만 쓴다.
   폰트는 vh 가 아니라 고정 px 로 둔다(화면 높이에 따라 널뛰지 않게). */
.rlt-full--plain{background:${WHITE};color:${TEXT};}
.rlt-full--plain .rlt-full-head{font-size:24px;font-weight:700;line-height:1.4;
  color:${TEXT};}
.rlt-full--plain .rlt-full-sub{margin-top:12px;font-size:16px;font-weight:500;
  opacity:1;line-height:1.5;color:${TEXT};}
`;

export default function Roulette() {
  // URL 로 대상 이벤트를 못박는다. 없으면 기존 동작(RUNNING 중 최신 1건).
  const params = useParams();
  const routeEventNo =
    params.eventNo && Number.isFinite(Number(params.eventNo))
      ? Number(params.eventNo)
      : null;
  const activeUrl = useMemo(() => buildActiveUrl(routeEventNo), [routeEventNo]);

  const containerRef = useRef(null);
  const wheelRef = useRef(null);
  const slotsRef = useRef(null);

  // 휠 재생성 리비전. 서버 slots 가 도착하거나 구성이 바뀔 때마다 올린다.
  // ★회차 번호를 쓰면 안 된다 — 같은 값이면 React 가 리렌더를 건너뛰어
  //  같은 회차 안에서 soldOut 만 바뀐 경우를 놓친다.
  // ★0 은 "아직 슬롯을 못 받음" 을 뜻한다.
  const [wheelRev, setWheelRev] = useState(0);

  const lastIndexRef = useRef(-1); // 직전에 멈춘 칸 — 연속 같은 칸 방지
  const pendingRef = useRef(null); // 회전 중인 추첨 결과. onRest 에서 꺼내 쓴다
  const spinLockRef = useRef(false); // 중복 클릭 방지(상태 반영 전에 즉시 잠금)
  const eventRef = useRef(null); // 폴링 콜백에서 최신 회차를 읽기 위한 ref

  const [screen, setScreen] = useState('loading'); // loading|ready|none|soldout|ended|loadfail
  const [eventData, setEventData] = useState(null);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    eventRef.current = eventData;
  }, [eventData]);

  // 휠 생성. 칸 배치는 slotsRef 에 고정돼 있고, 회차가 바뀔 때만 다시 만든다.
  useEffect(() => {
    if (wheelRev === 0 || !slotsRef.current) return undefined;
    const container = containerRef.current;
    if (!container) return undefined;

    const wheel = new Wheel(container, {
      items: toWheelItems(slotsRef.current),
      isInteractive: false, // 드래그로 못 돌리게
      // itemLabelRadiusMax 를 0.35 -> 0.48 로 올린다.
      // ★spin-wheel 은 폰트 크기를 반지름 방향 폭(_labelMaxWidth)으로만
      //  계산하고 부채꼴의 각도 폭은 보지 않는다. 즉 이 값을 줄이면
      //  라벨이 얇아지는 게 아니라 폰트가 그만큼 커진다.
      // ★itemLabelFontSizeMax 는 상한일 뿐이라 실효 제어가 되지 않는다.
      // ★브라우저 콘솔 실측으로 0.48 이 적절함을 확인했다.
      itemLabelRadius: 0.72,
      itemLabelRadiusMax: 0.48,
      itemLabelFontSizeMax: 18,
      itemLabelAlign: 'center',
      itemLabelFont: "'Noto Sans KR','Malgun Gothic',sans-serif",
      itemLabelStrokeColor: 'rgba(0,0,0,0.25)',
      itemLabelStrokeWidth: 2,
      borderColor: AGOLD,
      borderWidth: 4,
      lineColor: LINE_TAUPE,
      lineWidth: 3,
      pointerAngle: 0, // 12시 방향. CSS 포인터와 일치
      onRest: e => {
        lastIndexRef.current = e.currentIndex;
        const drawn = pendingRef.current;
        pendingRef.current = null;
        if (drawn) {
          setResult(drawn);
        } else {
          spinLockRef.current = false;
          setSpinning(false);
        }
      },
    });
    wheelRef.current = wheel;

    return () => {
      wheel.remove();
      wheelRef.current = null;
    };
  }, [wheelRev]);

  // 회차가 바뀐 경우. 서버 slots 를 셔플해 새로 고정하고 휠을 재생성한다.
  // ★시드는 (eventNo, curRound) 다 — 같은 회차면 배치가 고정된다.
  //  eventNo 는 응답 body 가 원본이다. 없으면 URL 의 eventNo 로 대체한다.
  const applySlots = useCallback(
    body => {
      const eventNo = body.eventNo != null ? body.eventNo : routeEventNo;
      slotsRef.current = shuffleSlots(
        body.slots,
        makeSeed(eventNo, body.curRound)
      );
      lastIndexRef.current = -1;
      setWheelRev(v => v + 1);
    },
    [routeEventNo]
  );

  /**
   * 회차는 그대로이고 soldOut 구성만 바뀐 경우.
   * ★셔플하지 않는다 — 참가자가 보고 있는 칸 위치가 움직이면 안 된다.
   * itemNo 로 매칭해 slotsRef 의 soldOut 만 갱신하고 리비전을 올린다.
   */
  const syncSoldOut = useCallback(body => {
    const slots = slotsRef.current;
    if (!slots) return;
    const next = new Map(
      (body.slots ?? [])
        .filter(s => s.type === 'GIFT' && s.itemNo != null)
        .map(s => [s.itemNo, s.soldOut === true])
    );
    let changed = false;
    for (const slot of slots) {
      if (slot.type !== 'GIFT' || slot.itemNo == null) continue;
      const v = next.get(slot.itemNo);
      if (v !== undefined && v !== (slot.soldOut === true)) {
        slot.soldOut = v;
        changed = true;
      }
    }
    if (changed) setWheelRev(r => r + 1);
  }, []);

  // 마운트 시 진행중 이벤트 조회
  useEffect(() => {
    let cancelled = false;
    axios
      .get(activeUrl, { headers: JSON_HEADERS })
      .then(res => {
        if (cancelled) return;
        const body = unwrap(res);
        if (!body) {
          setScreen('none');
          return;
        }
        setEventData(body);
        applySlots(body);
        setScreen(body.soldOut === true ? 'soldout' : 'ready');
      })
      .catch(() => {
        if (!cancelled) setScreen('loadfail');
      });
    return () => {
      cancelled = true;
    };
  }, [activeUrl, applySlots]);

  // 대기·SOLD OUT 화면에서 5초 폴링.
  // ★ready 에서도 돌아야 한다 — 다른 경로로 회차가 소진되면 이 화면은 알 수 없다.
  useEffect(() => {
    if (screen !== 'ready' && screen !== 'soldout') return undefined;
    let cancelled = false;
    const timer = setInterval(() => {
      // 회전 중·결과 팝업이 떠 있는 동안은 건너뛴다 — 결과 처리와 충돌한다.
      if (spinLockRef.current) return;
      axios
        .get(activeUrl, { headers: JSON_HEADERS })
        .then(res => {
          if (cancelled) return;
          const body = unwrap(res);
          if (!body) {
            setScreen('none');
            return;
          }
          // baseRound 는 콜백 안에서 읽는다 — effect 생성 시점 값은 낡을 수 있다.
          const baseRound = eventRef.current
            ? eventRef.current.curRound
            : null;

          if (body.curRound !== baseRound) {
            // 회차가 바뀌면 상품 구성이 달라진다 — 셔플부터 다시.
            setEventData(body);
            applySlots(body);
            setError('');
            setScreen(body.soldOut === true ? 'soldout' : 'ready');
            return;
          }

          // 같은 회차 — 배치는 유지한 채 soldOut 만 반영하고,
          // 화면 상태가 서버와 어긋나 있으면 맞춘다.
          setEventData(body);
          syncSoldOut(body);
          const nextScreen = body.soldOut === true ? 'soldout' : 'ready';
          setScreen(prev => (prev === nextScreen ? prev : nextScreen));
        })
        .catch(() => {
          // 폴링 실패는 무시하고 다음 주기에 재시도
        });
    }, POLL_MS);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [screen, activeUrl, applySlots, syncSoldOut]);

  /**
   * 멈출 칸을 고른다.
   *  GIFT   당첨 상품의 itemNo 와 일치하는 칸 (이름이 아니라 번호로 찾는다 —
   *         같은 회차에 동명 상품이 2종 있을 수 있다). 보통 정확히 1칸이다.
   *  COUPON 쿠폰 칸 중 랜덤. 직전 칸은 가능하면 피한다.
   */
  const pickSlotIndex = useCallback(body => {
    const slots = slotsRef.current ?? [];
    const indicesOf = fn => {
      const out = [];
      for (let i = 0; i < slots.length; i += 1) {
        if (fn(slots[i])) out.push(i);
      }
      return out;
    };

    let pool = [];
    if (body.resultType === 'GIFT') {
      pool = indicesOf(s => s.type === 'GIFT' && s.itemNo === body.itemNo);
      if (pool.length === 0) {
        // 6종 이상 등록돼 휠에 안 올라온 상품이 당첨된 경우 등.
        console.error('[roulette] 당첨 상품에 해당하는 칸이 없다', body);
        pool = indicesOf(s => s.type === 'GIFT');
      }
    } else if (body.resultType === 'COUPON') {
      pool = indicesOf(s => s.type === 'COUPON');
    }

    if (pool.length === 0) return -1;
    // GIFT 는 후보가 1칸뿐이라 직전 칸 회피가 걸리면 그대로 되돌린다.
    const avoided = pool.filter(i => i !== lastIndexRef.current);
    const use = avoided.length > 0 ? avoided : pool;
    return use[Math.floor(Math.random() * use.length)];
  }, []);

  const releaseButton = useCallback(() => {
    spinLockRef.current = false;
    setSpinning(false);
  }, []);

  const handleStart = useCallback(() => {
    if (spinLockRef.current) return;
    const wheel = wheelRef.current;
    const ev = eventRef.current;
    if (!wheel || !ev) return;

    spinLockRef.current = true; // 즉시 잠금
    setSpinning(true);
    setError('');

    axios
      .post(
        Config.API_EVENT_DRAW,
        { eventNo: ev.eventNo },
        { headers: JSON_HEADERS }
      )
      .then(res => {
        const body = unwrap(res);
        if (!body) {
          console.error('[roulette] draw 응답 없음', res && res.data);
          setError('추첨 결과를 받지 못했습니다. 다시 시도해 주세요.');
          releaseButton();
          return;
        }
        if (body.noSlot === true) {
          releaseButton();
          setScreen('ended');
          return;
        }
        const idx = pickSlotIndex(body);
        if (idx < 0) {
          // 서버 설계상 발생하지 않는 조합. 발생 시 서버 버그이므로 응답 전문을 남긴다.
          console.error('[roulette] draw resultType 이상', body);
          setError('추첨 결과를 확인할 수 없습니다. 다시 시도해 주세요.');
          releaseButton();
          return;
        }
        pendingRef.current = body;
        wheel.spinToItem(idx, SPIN_DURATION, true, SPIN_REVOLUTIONS, 1);
      })
      .catch(() => {
        pendingRef.current = null;
        setError('추첨에 실패했습니다. 다시 시도해 주세요.');
        releaseButton();
      });
  }, [pickSlotIndex, releaseButton]);

  /** 소진된 상품 칸을 회색으로. ★배열 교체 없이 Item setter 로만 바꾼다. */
  const markSlotSoldOut = useCallback(itemNo => {
    const wheel = wheelRef.current;
    if (!wheel || itemNo == null) return;
    const i = wheel.items.findIndex(it => it.value === itemNo);
    if (i < 0) {
      console.error('[roulette] 소진 처리할 칸을 찾지 못했다', itemNo);
      return;
    }
    // setter 가 wheel.refresh() 를 부른다 — 다시 그리라고 따로 시킬 필요가 없다.
    // ★refresh() 는 resize() 를 부르지 않아 폰트 크기는 재계산되지 않는다.
    //  'SOLD OUT' 은 자르기 상한(한글 9자)보다 좁아 넘칠 일이 없다.
    wheel.items[i].label = SOLD_OUT_LABEL;
    wheel.items[i].backgroundColor = GRAY_BG;
    wheel.items[i].labelColor = GRAY_LABEL;
    // slotsRef 에도 반영해 둔다. 회차 재생성 없이 다시 그릴 때 회색이 유지된다.
    const slot = (slotsRef.current ?? []).find(s => s.itemNo === itemNo);
    if (slot) slot.soldOut = true;
  }, []);

  const handleConfirm = useCallback(() => {
    const drawn = result;
    setResult(null);
    releaseButton();
    if (!drawn) return;
    if (drawn.soldOutItemNo != null) markSlotSoldOut(drawn.soldOutItemNo);
    if (drawn.soldOut === true) setScreen('soldout');
  }, [result, releaseButton, markSlotSoldOut]);

  const curRound = eventData ? eventData.curRound : null;
  const roundCnt = eventData ? eventData.roundCnt : null;
  // 마지막 회차가 소진되면 다음 회차가 없다 — 안내 문구가 달라야 한다.
  const isFinalRound = curRound !== null && curRound === roundCnt;
  const isGift = result && result.resultType === 'GIFT';

  return (
    <div className="rlt-root">
      <style>{RLT_CSS}</style>

      <div className="rlt-logo" aria-label="내기프트" role="img" />

      <div className="rlt-top">
        <div className="rlt-title">
          {eventData && eventData.eventName ? eventData.eventName : ' '}
        </div>
        <div className="rlt-round">
          {eventData
            ? `${eventData.curRound}회차 / ${eventData.roundCnt}회차`
            : ''}
        </div>
      </div>

      <div className="rlt-stage">
        <div className="rlt-wheel-wrap">
          <div className="rlt-ring" aria-hidden="true" />
          <div className="rlt-wheel" ref={containerRef} />
          <div className="rlt-bulbs" aria-hidden="true">
            {BULBS.map(deg => (
              <span
                key={deg}
                className="rlt-bulb"
                style={{ transform: `rotate(${deg}deg)` }}
              />
            ))}
          </div>
          <div className="rlt-hub" aria-hidden="true" />
          <div className="rlt-pointer" aria-hidden="true" />
        </div>
      </div>

      <div className="rlt-bottom">
        <button
          type="button"
          className="rlt-start"
          onClick={handleStart}
          disabled={
            screen !== 'ready' || spinning || !eventData || wheelRev === 0
          }
        >
          START
        </button>
      </div>

      {error ? <div className="rlt-error">{error}</div> : null}

      {result ? (
        <div className="rlt-dim">
          <div className="rlt-panel">
            <div
              className={`rlt-badge ${
                isGift ? 'rlt-badge--gift' : 'rlt-badge--coupon'
              }`}
            >
              {isGift ? '기프트 당첨' : '기프트 미당첨'}
            </div>
            {isGift ? (
              <div className="rlt-panel-head">축하합니다!</div>
            ) : null}
            <div
              className={`rlt-panel-body${
                isGift ? '' : ' rlt-panel-body--lead'
              }`}
            >
              {isGift ? result.itemName || '기프트 당첨' : '할인쿠폰을 드립니다'}
            </div>
            {isGift ? null : (
              <div className="rlt-panel-note">직원에게 화면을 보여주세요</div>
            )}
            <button
              type="button"
              className="rlt-panel-btn"
              onClick={handleConfirm}
            >
              확인
            </button>
          </div>
        </div>
      ) : null}

      {screen === 'loading' ? (
        <div className="rlt-full rlt-full--plain">
          <div className="rlt-full-sub">불러오는 중입니다...</div>
        </div>
      ) : null}

      {screen === 'none' ? (
        <div className="rlt-full rlt-full--plain">
          <div className="rlt-full-head">진행 중인 이벤트가 없습니다</div>
        </div>
      ) : null}

      {screen === 'ended' ? (
        <div className="rlt-full rlt-full--plain">
          <div className="rlt-full-head">이벤트가 종료되었습니다</div>
        </div>
      ) : null}

      {screen === 'loadfail' ? (
        <div className="rlt-full rlt-full--plain">
          <div className="rlt-full-head">이벤트 정보를 불러오지 못했습니다</div>
          <div className="rlt-full-sub">
            네트워크를 확인한 뒤 새로고침해 주세요.
          </div>
        </div>
      ) : null}

      {screen === 'soldout' ? (
        <div className="rlt-full">
          <div className="rlt-full-head">
            {curRound !== null ? `${curRound}회차 ` : ''}기프트 SOLD OUT!
          </div>
          {isFinalRound ? (
            <div className="rlt-full-sub">
              오늘의 기프트가 모두 소진되었습니다
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
